import React from 'react';
import { Link } from "react-router-dom";
import {
	Card,
	Input,
	Button,
	Table,
	Modal,
	message,
	Alert,
	Tag,
	Tooltip,
	Typography,
	Pagination,
	Select,
	Spin,
} from 'antd';
import {
	SearchOutlined,
	PlusOutlined,
	FormOutlined,
	CloseSquareOutlined,
	ExclamationCircleOutlined,
	DiffOutlined,
	RedoOutlined,
	AppstoreOutlined,
	CarOutlined,
	ClusterOutlined,
	UndoOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data Tipe',
	apiUrl: { data: 'master/api/tipe/' },
	pageUrl: { form: '/admin/tipe/form/' },
	breadCrumb: [
		<span><DiffOutlined /> Master</span>,
		'Tipe',
	],
};

const config = new Config();

class DataTipe extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
			filterJenis: undefined,
			loadingJenisFilter: false,
			listJenisFilter: [],
			filterMerek: undefined,
			loadingMerekFilter: false,
			listMerekFilter: [],
			filterTahun: undefined,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadJenisFilter()
			.then(() => this.loadMerekFilter())
			.then(() => this.getData());
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	async loadMerekFilter() {
		this.setState({ loadingMerekFilter: true });
		await this.props.ajaxViewHandler('get', 'master/api/merek/?limit=1000');
		if (this.props.isSuccess) {
			const data = this.props.responseMsg;
			const results = data.results || (Array.isArray(data) ? data : []);
			this.setState({ listMerekFilter: results });
		}
		this.setState({ loadingMerekFilter: false });
	}

	async loadJenisFilter() {
		this.setState({ loadingJenisFilter: true });
		await this.props.ajaxViewHandler('get', 'master/api/jenis/kendaraan/?limit=1000');
		if (this.props.isSuccess) {
			const data = this.props.responseMsg;
			const results = data.results || (Array.isArray(data) ? data : []);
			this.setState({ listJenisFilter: results });
		}
		this.setState({ loadingJenisFilter: false });
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showRestoreConfirm(id) {
		Modal.confirm({
			title: 'Aktifkan Tipe',
			icon: <UndoOutlined style={{ color: '#52c41a' }} />,
			content: 'Data tipe akan diaktifkan kembali dan dapat digunakan untuk transaksi baru.',
			okText: 'Aktifkan',
			okButtonProps: { style: { background: '#52c41a', borderColor: '#52c41a' } },
			cancelText: 'Batal',
			onOk: () => this.prosesRestore(id),
		});
	}

	prosesRestore(id) {
		message.loading({ content: 'Mengaktifkan...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + id + '/restore/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data tipe berhasil diaktifkan kembali', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal mengaktifkan data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Nonaktifkan Tipe',
			icon: <ExclamationCircleOutlined />,
			content: 'Data tipe akan dinonaktifkan dan tidak bisa digunakan untuk transaksi baru. Data tetap tersimpan.',
			okText: 'Nonaktifkan',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data tipe berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					const errTitle = 'Gagal menghapus data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText, jenis = this.state.filterJenis, merek = this.state.filterMerek, tahun = this.state.filterTahun) {
		this.setState({ loadingData: true });
		let url = configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search + '&include_deleted=true';
		if (jenis) url += '&jenis=' + jenis;
		if (merek) url += '&merek=' + merek;
		if (tahun) url += '&tahun=' + tahun;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val, this.state.filterJenis, this.state.filterMerek, this.state.filterTahun);
		}, 400);
	};

	handleFilterJenisChange = (val) => {
		this.setState(
			prev => ({ filterJenis: val || undefined, filterMerek: undefined, pagination: { ...prev.pagination, current: 1 } }),
			() => this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.filterJenis, undefined, this.state.filterTahun)
		);
	};

	handleFilterMerekChange = (val) => {
		this.setState(
			prev => ({ filterMerek: val || undefined, pagination: { ...prev.pagination, current: 1 } }),
			() => this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.filterJenis, this.state.filterMerek, this.state.filterTahun)
		);
	};

	handleFilterTahunChange = (val) => {
		this.setState(
			prev => ({ filterTahun: val || undefined, pagination: { ...prev.pagination, current: 1 } }),
			() => this.getData(this.state.pagination.pageSize, 0, this.state.searchText, this.state.filterJenis, this.state.filterMerek, this.state.filterTahun)
		);
	};

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize, this.state.searchText, this.state.filterJenis, this.state.filterMerek, this.state.filterTahun);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize, this.state.searchText, this.state.filterJenis, this.state.filterMerek, this.state.filterTahun);
	};

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>;
				},
			},
			{
				title: 'Kode',
				dataIndex: 'kode',
				key: 'kode',
				width: 130,
				align: 'center',
				render: (val) => (
					<Tag style={{
						borderRadius: 20, fontWeight: 600, fontSize: 11,
						background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', letterSpacing: 1,
					}}>
						{val || '—'}
					</Tag>
				),
			},
			{
				title: 'Nama Tipe',
				dataIndex: 'nama',
				key: 'nama',
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{
							width: 34, height: 34, borderRadius: 8,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
						}}>
							<AppstoreOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{
				title: 'Jenis Kendaraan',
				dataIndex: 'jenis_nama',
				key: 'jenis_nama',
				width: 160,
				render: (val) => val ? (
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<ClusterOutlined style={{ color: '#52c41a', fontSize: 13 }} />
						<Text style={{ fontSize: 13 }}>{val}</Text>
					</div>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Merek',
				dataIndex: 'merek_nama',
				key: 'merek_nama',
				width: 160,
				render: (val) => val ? (
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<CarOutlined style={{ color: '#1e4d8a', fontSize: 13 }} />
						<Text style={{ fontSize: 13 }}>{val}</Text>
					</div>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Status',
				dataIndex: 'deleted_at',
				key: 'status',
				width: 110,
				align: 'center',
				render: (val) => val
					? <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}>Tidak Aktif</Tag>
					: <Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>Aktif</Tag>,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 100,
				fixed: 'right',
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							{row.deleted_at ? (
								<Button size="small" shape="circle" type="primary" ghost disabled>
									<FormOutlined />
								</Button>
							) : (
								<Link to={configClass.pageUrl.form + row.id}>
									<Button size="small" shape="circle" type="primary" ghost>
										<FormOutlined />
									</Button>
								</Link>
							)}
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan">
								<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
									<CloseSquareOutlined />
								</Button>
							</Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali">
								<Button size="small" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
									onClick={() => this.showRestoreConfirm(row.id)}
								>
									<UndoOutlined />
								</Button>
							</Tooltip>
						)}
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{
					borderRadius: 14, marginBottom: 12,
					boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
					border: '1px solid #f0f0f0', overflow: 'hidden',
				}}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<AppstoreOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>
							{row.nama}
						</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
							<Tag style={{
								borderRadius: 20, fontSize: 11, margin: 0,
								background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600,
							}}>
								{row.kode || '—'}
							</Tag>
							{row.jenis_nama && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, color: '#389e0d', borderColor: '#b7eb8f', background: '#f6ffed' }}>
									<ClusterOutlined style={{ marginRight: 3 }} />{row.jenis_nama}
								</Tag>
							)}
							{row.merek_nama && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0 }}>
									<CarOutlined style={{ marginRight: 3 }} />{row.merek_nama}
								</Tag>
							)}
							{row.deleted_at
								? <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>Tidak Aktif</Tag>
								: <Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>Aktif</Tag>
							}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Tooltip title={row.deleted_at ? 'Aktifkan dulu untuk mengedit' : 'Edit'}>
							{row.deleted_at ? (
								<Button size="middle" shape="circle" type="primary" ghost disabled><FormOutlined /></Button>
							) : (
								<Link to={configClass.pageUrl.form + row.id}>
									<Button size="middle" shape="circle" type="primary" ghost><FormOutlined /></Button>
								</Link>
							)}
						</Tooltip>
						{!row.deleted_at ? (
							<Tooltip title="Nonaktifkan">
								<Button size="middle" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
									<CloseSquareOutlined />
								</Button>
							</Tooltip>
						) : (
							<Tooltip title="Aktifkan kembali">
								<Button size="middle" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
									onClick={() => this.showRestoreConfirm(row.id)}
								>
									<UndoOutlined />
								</Button>
							</Tooltip>
						)}
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText,
			filterJenis, loadingJenisFilter, listJenisFilter,
			filterMerek, loadingMerekFilter, listMerekFilter,
			filterTahun } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-tipe-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px;
							color: #0f2847; border-bottom: 2px solid #d0dff5;
						}
						.data-tipe-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px; vertical-align: middle;
						}
						.data-tipe-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.data-tipe-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.data-tipe-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.data-tipe-wrap .row-nonaktif > td { opacity: 0.55; background: #fff9f9 !important; }
						.data-tipe-wrap .row-nonaktif:hover > td { opacity: 0.75 !important; background: #fff1f0 !important; }
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-tipe-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* ── Header ── */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<AppstoreOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} tipe terdaftar{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => this.setState(
										prev => ({ searchText: '', filterJenis: undefined, filterMerek: undefined, filterTahun: undefined, pagination: { ...prev.pagination, current: 1 } }),
										() => this.getData(this.state.pagination.pageSize, 0, '', undefined, undefined, undefined)
									)}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button type="primary" icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah Tipe'}
								</Button>
							</Link>
						</div>
					</div>

					{/* ── Filter & Search bar ── */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
							<Text type="secondary" style={{ fontSize: 12 }}>
								{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
							</Text>
							<Select
								allowClear
								showSearch
								optionFilterProp="children"
								placeholder={loadingJenisFilter ? <><Spin size="small" /> Memuat...</> : 'Semua jenis kendaraan'}
								loading={loadingJenisFilter}
								style={{ borderRadius: 8, minWidth: isMobile ? 160 : 200 }}
								size="middle"
								value={filterJenis}
								onChange={this.handleFilterJenisChange}
							>
								{listJenisFilter.map(item => (
									<Select.Option key={item.id} value={item.id}>
										{item.kode ? item.kode + ' - ' + item.nama : item.nama}
									</Select.Option>
								))}
							</Select>
							<Select
								allowClear
								showSearch
								optionFilterProp="children"
								placeholder={loadingMerekFilter ? <><Spin size="small" /> Memuat...</> : 'Semua merek'}
								loading={loadingMerekFilter}
								style={{ borderRadius: 8, minWidth: isMobile ? 140 : 180 }}
								size="middle"
								value={filterMerek}
								onChange={this.handleFilterMerekChange}
							>
								{listMerekFilter.map(item => (
									<Select.Option key={item.id} value={item.id}>
										{item.kode ? item.kode + ' - ' + item.nama : item.nama}
									</Select.Option>
								))}
							</Select>
							<Select
								allowClear
								showSearch
								optionFilterProp="children"
								placeholder="Semua tahun buat"
								style={{ borderRadius: 8, minWidth: isMobile ? 110 : 145 }}
								size="middle"
								value={filterTahun}
								onChange={this.handleFilterTahunChange}
							>
								{Array.from({ length: new Date().getFullYear() - 1969 }, (_, i) => new Date().getFullYear() - i).map(y => (
									<Select.Option key={y} value={y}>{y}</Select.Option>
								))}
							</Select>
						</div>
						<Input
							placeholder="Cari nama atau kode tipe..."
							allowClear size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 300 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => this.setState(
								prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
								() => this.getData(this.state.pagination.pageSize, 0, '', this.state.filterJenis, this.state.filterMerek, this.state.filterTahun)
							)}
						/>
					</div>

					{/* ── Konten ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize}
											total={pagination.total} onChange={this.handleMobilePageChange}
											showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								rowClassName={(row) => row.deleted_at ? 'row-nonaktif' : ''}
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(DataTipe);
